<template>
  <div>
    <g-info :info="info"/>
    <g-menu />
  </div>
</template>
<script>
import GInfo from "./components/Info";
import GMenu from "./components/Menu";
import { OrderModel } from "@models/common/order";
import { ERR_OK } from "@/common";
const orderModel = new OrderModel();
export default {
  data() {
    return {
      info: {}
    };
  },
  methods: {
    getData() {
      orderModel.getHomeDataStat({
        merchid: localStorage.id
      }).then(res => {
        if(res.code == ERR_OK) {
          this.info = res.data
        }
      });
    }
  },
  components: {
    GInfo,
    GMenu
  },
  created() {
    this.getData()
  }
};
</script>

<style lang="stylus" scoped></style>
